import {LOGOUT, REFRESH_MENU} from "../actionType"

function refreshMenu(){
    return {
        type:REFRESH_MENU
    }
}
function logout(){
    return {
        type:LOGOUT
    }
}

export {refreshMenu,logout}
